import { render, staticRenderFns } from "./DesignAndPosition.vue?vue&type=template&id=fafac65a"
import script from "./DesignAndPosition.vue?vue&type=script&lang=js"
export * from "./DesignAndPosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports